module.exports = __webpack_public_path__ + "static/media/Alien.47ad5904.png";